<lib-message [type]="'tip'" [dismissId]="'snippetsTip'" [className]="'push-bottom'">
	<div>
		<h3>📌 About Snippets</h3>
		<p>
			<strong>Snippets</strong> are reusable pieces of text you can quickly insert into your workouts, programs,
			or client notes. They’re designed to save you time and ensure consistency across your coaching.
		</p>

		<p>Use snippets for:</p>
		<ul>
			<li>Warm-up or cooldown instructions</li>
			<li>Exercise technique cues</li>
			<li>Client check-in reminders</li>
			<li>Common coaching notes or disclaimers</li>
			<li>Any text you find yourself typing repeatedly</li>
		</ul>

		<p>Instead of rewriting the same information each time, create a snippet once and reuse it wherever needed.</p>

		<p>
			<strong>Pro tip:</strong> Organize your snippets by category (e.g., Warm-Up, Mobility, Nutrition Tips) to
			make them easy to find when building sessions.
		</p>
	</div>
</lib-message>

@if (table(); as table) {
<lib-card>
	<lib-table [table]="table"></lib-table>
</lib-card>
}
